import type { ComponentProps } from 'react';
import type { SeoFooterTabs } from '@property.com.au/ui-kit';
import { SeoFooterFragment } from '../types';

export const mapApiFooterToSeoFooter = ({
  footerTabsV2: footerTabs,
}: SeoFooterFragment): ComponentProps<typeof SeoFooterTabs> | null => {
  if (!footerTabs?.tabs) return null;

  return {
    title: footerTabs?.title,
    tabs: footerTabs?.tabs.map((tab) => ({
      name: tab.name,
      tabContent: {
        title: tab.tabContent?.title,
        links: tab.tabContent?.links?.map((link) => ({
          title: link.title,
          url: link.url,
          clickThroughTracking: {
            pathname: link.tracking?.clickThroughTracking?.pathname,
            page: link.tracking?.clickThroughTracking?.page,
            element: link.tracking?.clickThroughTracking?.element,
            sourceType: link.tracking?.clickThroughTracking?.sourceType,
          },
        })),
      },
    })),
  };
};
